import React, { useEffect, useMemo, useState } from 'react'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import TableItem from '../TableItem/TableItem'
import { mainApi } from '../../../../../store/services/mainApi'

const RouteRow = ({ route, index, orderRows }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = () => setIsOpen(!isOpen)

  const { data: carInfo, isLoading } = mainApi.useGetVanByIdQuery(route.vehicle, { skip: !route.vehicle })

  const routeOrders = orderRows.filter((order) => order.logistic?.routeId === route._id)

  return (
    <div className='route-row'>
      <div className='table-item route-header' onClick={toggleOpen}>
        <div className='cell code'>{route.name || ''}</div>
        {route.name !== 'Wait List' && <div className='cell time'>{route.date || ''}</div>}
        {route.name !== 'Wait List' && <div className='cell time'>{carInfo?.number || ''}</div>}
        {route.name !== 'Wait List' && <div className='cell time'>{`0 /` + carInfo?.maxWeight || ''}</div>}
        {route.name !== 'Wait List' && <div className='cell time'>{`0 /` + carInfo?.maxCapacity || ''}</div>}

        {route.name !== 'Wait List' && <div className='cell driver'>{route.driver ? <img src={route.driver} alt='driver' /> : null}</div>}
        {route.name !== 'Wait List' && <div className='cell picker'>{route.picker ? <img src={route.picker} alt='picker' /> : null}</div>}
        <div className='cell toggle-icon'>{isOpen ? '▲' : '▼'}</div>
      </div>

      {isOpen && (
        <Droppable droppableId={route._id}>
          {(provided) => (
            <div
              className='route-orders'
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{ padding: '8px 0' }} // Добавленные отступы
            >
              {routeOrders.map((order, idx) => (
                <Draggable key={order._id} draggableId={order._id} index={order.logistic ? order.logistic.position : idx}>
                  {(provided) => (
                    <div className='order-card' ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                      <TableItem data={order} />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      )}
    </div>
  )
}

export default RouteRow
